import type { FaireProductEntity } from "../../entity_types/product";

export const atc_toast_5: FaireProductEntity = {
  token: "atc_toast_5",
  type: "product",
  name: "Hand-Poured Beeswax Tapers",
  brandName: "Big Dipper Wax Works",
  imageUrl: "",
  priceDollars: 8.0,
  msrpDollars: 16.0,
  description: "Migrated search/ATC mock product",
  tags: ["search", "prototype"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
